import { useEffect, useState } from "react";

import identity from "lodash/identity";
import pickBy from "lodash/pickBy";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router";

export const useSearchParams = (search: string) => {
  const [searchParams, setSearchParams] = useState(
    queryString.parse(search, { arrayFormat: "bracket" })
  );

  useEffect(() => {
    setSearchParams(queryString.parse(search, { arrayFormat: "bracket" }));
  }, [search]);

  return searchParams;
};

export const useUpdateSearch = (pathname: string, search: string) => {
  const navigate = useNavigate();
  const handleSearchClick = (value: any) => {
    const params = value;
    params.page = Number.isNaN(params?.page) ? "1" : params?.page;
    // delete params?.pageIndex
    navigate(
      `${pathname}?${queryString.stringify(pickBy(params, identity), {
        arrayFormat: "bracket",
        skipEmptyString: true,
      })}`
    );
  };

  const handleChangePageSize = (index: number, size: number | undefined) => {
    const searchParams = queryString.parse(search);
    searchParams.pageSize = size?.toString() ?? "";

    searchParams.pageIndex = index?.toString();
    navigate(`${pathname}?${queryString.stringify(searchParams)}`);
  };

  return { handleSearchClick, handleChangePageSize };
};
